import toast from "react-hot-toast";
import * as api from "../Api/index.js";

export const signin = (formData, navigate, loginAnswer) => async (dispatch) => {
  let loggingInId;
  try {
    loggingInId = toast.loading("We are logging you in...");
    const { data } = loginAnswer
      ? { data: loginAnswer }
      : await api.signIn(formData);
    // Password right, authenticator code still to come: the login page asks
    // for it, then calls signin again with the answer
    if (data.twoFactor) {
      toast.remove(loggingInId);
      return data;
    }
    dispatch({ type: "AUTH", data });
    toast.remove(loggingInId);
    toast.success("You are in.");

    navigate("/investment");
    window.location.reload();
  } catch (error) {
    toast.remove(loggingInId);
    const dataError = error.response.data.message;
    toast.error(dataError);
  }
};

export const signup = (formData, navigate) => async (dispatch) => {
  try {
    const { data } = await api.signup(formData);
    dispatch({ type: "AUTH", data });
    navigate("/");
  } catch (error) {}
};
//  forgot password
export const forgetPassword = (postData) => async (dispatch) => {
  try {
    const { data } = await api.forgotPassword(postData);
    dispatch({ type: "FORGET_PASSWORD", payload: data });
    const emailSentMessage =
      "Please check your email, we have sent you reset link";
    dispatch({ type: "EMAIL_SENT_TO_USER", emailSentMessage });
  } catch (error) {
    const emailSendingError = error.response.data.message;
    dispatch({ type: "EMAIL_SENDING_ERROR", emailSendingError });
  }
};
//  forgot password
export const resetPassword = (token, postData) => async (dispatch) => {
  try {
    const { data } = await api.resetPassword(token, postData);
    dispatch({ type: "RESET_USER_PASSWORD", payload: data });
    const message = "password successfully changed";
    dispatch({ type: "RESET_USER_PASSWORD_SUCCESS", message });
  } catch (error) {
    const resetError = error.response.data.message;
    dispatch({ type: "RESET_USER_PASSWORD_ERROR", resetError });
  }
};
// change password
export const changePassword = (postData) => async (dispatch) => {
  try {
    const { data } = await api.changePassword(postData);
    dispatch({ type: "CHANGE_MY_PASSWORD", payload: data });
    const changeMessage = "password successfully changed";
    dispatch({ type: "CHANGE_USER_PASSWORD_SUCCESS", changeMessage });
  } catch (error) {
    const changeError = error.response.data.message;
    dispatch({ type: "CHANGE_USER_PASSWORD_ERROR", changeError });
  }
};
